"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
var _axios = _interopRequireDefault(require("@/utils/axios"));
var _utils = require("../utils");
var _antDesignVue = require("ant-design-vue");
var _default = exports.default = {
  name: 'BasisInfiniteSelect',
  // 无限下拉选择器：通过对本地数据进行分页加载实现
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  },
  props: {
    ..._antDesignVue.Select.props,
    value: {
      type: [String, Array],
      default: undefined
    },
    // options 数据 array<{value, label, [disabled, key, title]}>
    // 只当做数据来源。内部手动构造 selectOption 节点
    options: {
      type: Array,
      default: undefined
    },
    // 设置 Select 的模式为多选或标签 'default' | 'multiple' | 'tags' | 'combobox'
    mode: {
      type: String,
      default: 'default'
    },
    // 默认选中的值
    defaultValue: {
      type: [String, Array],
      default: undefined
    },
    // 自定义属性 - 默认options配置
    defaultOptions: {
      type: Array,
      default: () => []
    },
    maxTagCount: {
      type: Number,
      default: 1
    },
    maxTagTextLength: {
      type: Number,
      default: 4
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 上拉触底事件触发时距页面底部距离
    onReachBottomDistance: {
      type: Number,
      default: 50
    },
    // 每次加载的数量
    pageSize: {
      type: Number,
      default: 15
    },
    // option展示时对应的字段
    replaceFields: {
      type: Object,
      default: () => {
        return {
          value: 'value',
          label: 'label'
        };
      }
    },
    // 自定义属性 - 获取数据接口链接或者请求方法
    method: {
      type: [String, Function, Promise],
      default: '' // 如 '/v1/data/list' 或 通过api配置的 getDataList 方法 或 getDataList(params)，返回Promise。
    },
    // 自定义属性 - 获取数据接口参数。method 为Promise时，该参数不生效。
    params: {
      type: Object,
      default: () => {}
    },
    // 自定义属性 - 在数据渲染前对接口返回的数据进行格式转换
    transformDataSource: {
      type: Function,
      default: undefined
      // default: (data) => {
      // 在这里对数据进行转换
      // data.forEach((item) => (item.tradeTime = 222))
      // }
    },
    // 自定义属性 - v-model和change事件返回的数据转成英文逗号连接的字符串，默认返回数组
    returnString: {
      type: Boolean,
      default: true
    },
    // 自定义属性 - replaceFields.value对应的类型，如果为number，且returnString为true，需要对v-model的值进行格式转换
    valueType: {
      type: String,
      default: 'string',
      validator: value => ['number', 'string'].includes(value)
    },
    // 自定义属性 - 是否显示全选、取消全选按钮
    showSelectAllBtn: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 是否分页
    pagination: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 分页加载时用作搜索条件的字段名称
    searchField: {
      type: String,
      default: undefined
    },
    // 自定义属性 - 默认选中第一个数据 2023.02.07新增
    defaultSelectedFirstNode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: undefined,
      // 当前选中的值
      dataSource: [],
      // 接口或外部传入的原始数据
      filterOptions: [],
      targetLoading: false,
      searchValue: undefined,
      rawData: [],
      pageConfig: {
        pageNo: 1,
        pageSize: this.pageSize,
        total: 0,
        done: false
      }
    };
  },
  computed: {
    // 最终提交给接口使用的参数
    targetParams() {
      const {
        pagination,
        pageConfig,
        params,
        searchField,
        searchValue
      } = this;
      // 自动添加分页参数
      const pageParams = pagination ? {
        pageNo: pageConfig.pageNo,
        pageSize: pageConfig.pageSize
      } : {};
      const searchParams = {};
      if (searchField && searchValue) searchParams[searchField] = searchValue;
      return _.merge({}, params, pageParams, searchParams);
    },
    targetProps() {
      const _props = _.cloneDeep(this.$props);
      delete _props.options; // 删除外部传入的options，只当做数据来源。内部手动构造 selectOption 节点
      delete _props.open; // ! 删除该属性，否则导致无法展开
      return _props;
    },
    // 过滤掉重复值
    uniqFilterOptions() {
      const {
        filterOptions,
        replaceFields
      } = this;
      const optionsList = [];
      return filterOptions.filter(item => {
        const _value = item[replaceFields.value];
        if (optionsList.includes(_value)) {
          return false;
        }
        optionsList.push(_value);
        return true;
      });
    },
    // 全部列表的value数组
    allTargetValue() {
      let target = this.dataSource;
      if (!!this.searchValue) {
        target = this.dataSource.filter(item => {
          const label = item[this.replaceFields.label];
          return label.indexOf(this.searchValue) > -1;
        });
      }
      return target.map(item => item[this.replaceFields.value]);
    }
  },
  watch: {
    defaultOptions: {
      handler(newVal, oldVal) {
        if (_.size(newVal) && !_.size(oldVal)) {
          this.rawData = newVal;
          this.transformData(newVal);
        }
      },
      immediate: true,
      deep: true
    },
    options: {
      handler(newVal, oldVal) {
        // 如果没有从外部传值进来，则使用接口获取数据
        if (oldVal === undefined && newVal === undefined) {
          this.getDataList();
        } else {
          this.transformData(newVal);
        }
      },
      immediate: true,
      deep: true
    },
    // 回填默认值
    defaultValue: {
      handler(val) {
        if (_.isEmpty(val)) return;
        if (Array.isArray(val)) {
          this.selected = val;
        } else if (val.indexOf(',') > -1 || ['multiple', 'tags'].includes(this.mode)) {
          this.selected = val.split(',');
        } else {
          this.selected = val;
        }
      },
      immediate: true,
      deep: true
    },
    value: {
      handler(val) {
        if (Array.isArray(val) && val.length > 0) {
          this.selected = val.filter(Boolean);
        } else if (val && val.indexOf(',') > -1) {
          const arr = val.split(',');
          const tempArr = [];
          if (this.valueType === 'number' && this.returnString === true) {
            // 对v-model的值进行格式转换
            arr.forEach(item => {
              const _item = parseInt(item);
              if (!tempArr.includes(_item)) tempArr.push(_item);
            });
            this.selected = tempArr;
          } else {
            this.selected = arr;
          }
        } else {
          // eslint-disable-next-line no-nested-ternary
          this.selected = _.isEmpty(val) ? undefined : this.valueType === 'number' ? Number(val) : val;
        }
      },
      immediate: true
    },
    selected: {
      handler(newVal, oldVal) {
        // !_.isEqual(newVal, oldVal) 只有新旧数据不相同才触发后续操作，否则会陷入死循环
        if (!_.isEqual(newVal, oldVal)) {
          const value = this.returnString && newVal ? newVal.toString() : newVal;
          this.$emit('input', this.labelInValue ? newVal : value);
          const valueArr = Array.isArray(value) ? value : value?.split(',') || [];
          const list = [];
          if (valueArr.length) {
            this.rawData.forEach(item => {
              if (valueArr.includes(item[this.replaceFields.value])) list.push(item);
            });
          }
          this.$emit('change', this.labelInValue ? newVal : value, list);
        }
      },
      immediate: true,
      deep: true
    },
    params(val, oldVal) {
      if (_.isEqual(val, oldVal)) return;
      _.size(this.options) ? this.transformData(this.options) : this.getDataList();
    },
    mode(val) {
      // 切换单选与多选时，单选取第一个值
      if (val === 'default' && !_.isEmpty(this.value)) this.selected = this.value.toString().split(',')[0];
    }
  },
  created() {
    this.init();
  },
  activated() {
    // 为了从其他页面切换回来当前页加载最新数据，确保数据的实时性
    if (_.isEmpty(this.options)) this.getDataList();
  },
  unmounted() {
    // 移除组件时，取消定时器
    this.debouncedSearch.cancel();
    this.handleScroll.cancel();
  },
  methods: {
    init() {
      // 滚动条滚动，无限拼接数据
      this.handleScroll = _.debounce(e => {
        const {
          target: {
            clientHeight,
            scrollTop,
            scrollHeight
          }
        } = e;
        // 是否触底
        const isReachBottom = clientHeight + scrollTop + this.onReachBottomDistance > scrollHeight;
        if (!isReachBottom) return;

        // 分页加载
        if (this.pagination) {
          const {
            pageNo,
            pageSize,
            total
          } = this.pageConfig;
          const num = Math.ceil(total / pageSize);
          if (pageNo >= num) {
            this.pageConfig.done = true;
            return;
          }
          this.pageConfig.pageNo++;
          this.getDataList();
        } else {
          // 一次性加载完毕
          this.targetLoading = true;
          const {
            dataSource,
            pageSize,
            filterOptions = []
          } = this;
          const currIndex = filterOptions.length;
          const allIndex = dataSource.length;
          const nextPageIndex = currIndex + pageSize;
          const nextFilterOptions = _.cloneDeep(dataSource).slice(currIndex, nextPageIndex > allIndex ? allIndex : nextPageIndex);
          // 去重
          this.filterOptions = [...new Set([...filterOptions, ...nextFilterOptions])];
          this.targetLoading = false;
        }
      }, 200);
      this.debouncedSearch = _.debounce(this.handleSearch, 200);
    },
    transformData(rawData) {
      if (!rawData) return;
      this.rawData = rawData;
      const dataSource = _.cloneDeep(rawData);

      // 进行数据格式转换
      if (typeof this.transformDataSource === 'function') this.transformDataSource(dataSource);
      this.dataSource = dataSource;
      this.getSelectedOptions();
    },
    // 获取数据
    async getDataList() {
      if (!this.method || this.targetLoading) return;
      this.targetLoading = true;
      const methodType = (0, _utils.getType)(this.method);
      if (methodType === 'promise') {
        this.method.then(res => {
          this.transformData(res);
          this.targetLoading = false;
        }).catch(() => {
          this.targetLoading = false;
        });
      } else {
        try {
          const res = methodType === 'function' ? await this.method(this.targetParams) : await _axios.default.get(this.method, this.targetParams);
          let data = res;
          if (this.pagination && !Array.isArray(res)) {
            const {
              current,
              total,
              records
            } = res;
            // 第一次才更新total
            if (current === 1 && !this.searchValue) this.pageConfig.total = total;
            if (this.searchValue) {
              // 搜索结果放在前面
              data = [...new Set([...records, ...this.rawData])];
            } else {
              data = [...new Set([...this.rawData, ...records])];
            }
          }
          this.transformData(data);
          this.targetLoading = false;
        } catch (error) {
          this.targetLoading = false;
        }
      }
    },
    // 得到下拉列表的数据
    getSelectedOptions() {
      this.targetLoading = true;
      let selected = this.selected;
      const {
        defaultSelectedFirstNode,
        searchValue = '',
        pageSize,
        replaceFields: {
          value,
          label
        }
      } = this;
      const dataSource = _.cloneDeep(this.dataSource);
      if (!Array.isArray(dataSource)) return;
      let tempFilterOptions = searchValue ? dataSource.filter(item => item[label] && item[label].indexOf(searchValue) !== -1) : dataSource;
      if (tempFilterOptions.length > pageSize && !this.pagination) {
        tempFilterOptions = tempFilterOptions.slice(0, pageSize);
      } else {
        tempFilterOptions = tempFilterOptions;
      }

      // 默认选中第一个数据
      if (defaultSelectedFirstNode && !selected && tempFilterOptions.length > 0) {
        selected = tempFilterOptions[0][value];
        this.selected = selected;
      }

      // 判断用户是否有选择
      if (selected) {
        // 从 options 中过滤出当前选中的数据
        const selectedOptions = dataSource.filter(item => {
          const _value = item[value];
          if (Array.isArray(selected) && selected.length > 0 && selected.includes(_value)) {
            return true;
          } else if (selected === _value) {
            return true;
          }
          return false;
        });
        // 把选中的选项排在前面
        selectedOptions.forEach(item => {
          const option = _.find(dataSource, {
            [value]: item[value]
          });
          if (option) tempFilterOptions.unshift(item);
        });
      }
      // 去重
      this.filterOptions = _.uniqBy(tempFilterOptions, value);
      this.targetLoading = false;
    },
    // 文本框值变化时回调
    handleSearch(value) {
      this.searchValue = value || '';
      this.$nextTick(() => {
        // 有分页且未加载完全部数据时重新从第一页开始加载
        if (this.pagination && !this.pageConfig.done) {
          this.pageConfig.pageNo = 1;
          this.getDataList();
        } else {
          this.getSelectedOptions();
        }
      });
    },
    handleBlur() {
      this.searchValue = undefined;
      // if (this.searchValue) {
      //   this.searchValue = undefined
      //   this.getSelectedOptions()
      // }
    },
    handleDropdown(open) {
      if (open) this.getSelectedOptions();
    },
    /**
     * @description: 全选或清空选中结果
     * @param {string} type all-全选 clear-清空
     */
    selectToggle(type) {
      const {
        selected
      } = this;
      // eslint-disable-next-line no-nested-ternary
      const oldSelected = Array.isArray(selected) ? selected : selected === undefined ? [] : [selected];
      this.selected = type === 'all' ? [...new Set([...oldSelected, ...this.allTargetValue])] : undefined;
    }
  }
};